(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ka-step-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.customElements.get('ka-step-guide')) return;

    class KaStepGuide extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const play = event.target.closest('[data-ka-sg-play]');
        if (play && this.contains(play)) {
          this.playVideo(play.closest('[data-ka-sg-media]'));
          return;
        }
        const tab = event.target.closest('[data-ka-sg-tab]');
        if (tab && this.contains(tab)) {
          this.activate(tab.dataset.index);
        }
      }

      playVideo(media) {
        if (!media) return;
        const wrap = media.querySelector('[data-ka-sg-video-wrap]');
        const video = wrap && wrap.querySelector('video');
        const pill = media.querySelector('[data-ka-sg-play]');
        if (!video) return;
        wrap.hidden = false;
        if (pill) pill.hidden = true;
        video.play().catch(function () {});
      }

      activate(index) {
        this.querySelectorAll('video').forEach(function (v) {
          v.pause();
        });
        this.querySelectorAll('[data-ka-sg-media], [data-ka-sg-panel]').forEach(function (el) {
          el.classList.toggle('ka-sg--active', el.dataset.index === index);
        });
        this.querySelectorAll('[data-ka-sg-tab]').forEach(function (tab) {
          const active = tab.dataset.index === index;
          tab.classList.toggle('ka-sg--active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        /* Reset any opened video back to its poster state when leaving the step. */
        this.querySelectorAll('[data-ka-sg-media]').forEach(function (media) {
          if (media.dataset.index === index) return;
          const wrap = media.querySelector('[data-ka-sg-video-wrap]');
          const pill = media.querySelector('[data-ka-sg-play]');
          if (wrap) wrap.hidden = true;
          if (pill) pill.hidden = false;
        });
      }
    }

    window.customElements.define('ka-step-guide', KaStepGuide);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
